import CurrencyHelper from "../../../../common/helpers/currency/CurrencyHelper";
import { SortHelper } from "../../../../common/helpers/sort/SortHelper";
import { IProduct } from "../../../../common/types";
import startCase from "lodash.startcase";

export const getSortedProductOptions = (products: IProduct[], language: string) =>
  products
    .map(
      ({
        id,
        sku,
        name,
        price_range: {
          minimum_price: {
            regular_price: { value, currency }
          }
        }
      }) => {
        const label = `${startCase(name)} ${CurrencyHelper.moneyFormatWithoutZeros(value, currency, language)}`;
        return { id, sku, label };
      }
    )
    .sort(({ label: label1 }, { label: label2 }) => SortHelper.alphabeticalSort(label1, label2));

export const getItemIndex = (length: number, index: number) => {
  const lastItem = index === length - 1 ? 'LastItem' : '';
  return index === 0 ? 'FirstItem' : lastItem;
}
